<template>
  <div class="content-warp main-height600">
    <div class="main-width">
      <div class="organization">
        <div class="organization-name"></div>
        <a-spin :spinning="loading">
          <div class="list">
            <a-collapse>
              <a-collapse-panel :key="'combat' + combatIndex" v-for="(combat, combatIndex) in data[curTeam].combats" :header="combat.combatName" :style="{background: $root.skin_number}">
                <div class="coach" v-for="(leader, leaderIndex) in data[curTeam].leaders" :key="'leader' + leaderIndex">
                  <label>{{leader.leaderType}}</label>
                  <div class="leader-list clearFloat" v-for="(leaderUser, leaderUserIndex) in leader.leaderDatas" :key="'leaderUser' + leaderUserIndex">
                    <p>
                      <img :src="leaderUser.head">
                      <span>{{leaderUser.name}}</span>
                    </p>
                  </div>
                </div>
                <div>
                  <div class="player" v-for="(combatDetails, combatDetailsIndex) in combat.combatDetails" :key="'combatDetails'+combatDetailsIndex">
                    <label>{{combatDetails.combatDetailName}}({{ combatDetails.players.length }}人)</label>
                    <div class="player-list" >
                      <span v-for="(player, playerIndex) in combatDetails.players" :key="'playerIndex'+playerIndex">
                        <img :src="player.head">
                        <p class="line">{{ player.name }}</p>
                      </span>
                    </div>
                  </div>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </a-spin>
        <div class="apply-step-warp">
          <button class="pre" @click="printExcel('insurance')" :style="{background:$root.skin_number}">下载保险凭证</button>
          <button class="next" @click="printExcel('signUp')" :style="{background:$root.skin_number}">打印报名列表</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const tableColumns = [
  { title: '项目1', dataIndex: 'combatName', key: 'combatName' }

]
const tableData = [
  {combatName: '团体赛'}, {combatName: '个人赛'}
]
export default {
  name: 'ChangeData',
  components: {
  },
  mounted () {
    // 初始化
    this.queryData()
  },
  created () {
    this.matchId = this.$route.query.matchId
  },
  data () {
    return {
      title: '查看报名数据',
      loading: false,
      data: [{}],
      curTeam: 0,
      openData: false,
      visible: false,
      tableColumns: tableColumns,
      tableData: tableData,
      skinColor: this.$root.skin_number,
      matchId: this.$route.query.matchId,
      agencyId: this.$route.query.agencyId,
      openStyle: {
        maxHeight: '1200px'
      },
      closeStyle: {
        maxHeight: '0px'
      },
      matchCombatMesVOS: [
        {combatName: '个人赛', combatDetailVOS: [{}]},
        {combatName: '团体赛', combatDetailVOS: [{}]},
        {combatName: '技法展示赛', combatDetailVOS: [{}]}
      ]
    }
  },
  methods: {
    teamChange (e) {
      this.curTeam = e.target.value
    },
    queryData () {
      this.loading = true
      this.$api.join.queryJoinData({matchId: this.$route.query.matchId, agencyId: this.agencyId}).then(res => {
        this.loading = false
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    printExcel (downloadType) {
      if (downloadType === 'signUp') {
        this.$api.join.exportSignDataExcel({matchId: this.$route.query.matchId, agencyId: this.agencyId, type: 2}).then(res => {
          this.readerDownload(res, downloadType)
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$api.join.exportInsurancePdf({matchId: this.$route.query.matchId, agencyId: this.agencyId}).then(res => {
          this.readerDownload(res, downloadType)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    readerDownload (res, downloadType) {
      let type = res.type
      // 如果返回的blob体的type是application/json类型，说明导出过程有异常，导出失败
      if (type.includes('application/json')) {
        let reader = new FileReader()
        var _this = this
        reader.onload = function (event) {
          let content = reader.result
          let message = JSON.parse(content).msg // 错误信息
          _this.$message.error(message)
        }
        reader.readAsText(res)
      } else {
        let blob = new Blob([res])
        let url = window.URL.createObjectURL(blob)
        let link = document.createElement('a')
        link.href = url

        link.download = downloadType == 'signUp' ? '报名数据.xls' : '保险凭证.pdf' // 下载后文件名
        document.body.appendChild(link)
        link.click() // 点击下载
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.organization{
  .organization-name{
    text-align: center;
    font-size: 16px;
    color: #000;
  }
  .list{
    margin-top: 30px;
    .coach,.guide{
      display: flex;
      padding: 10px 0;
      flex-direction: row;
      background-color: #fff;
      box-shadow: rgba(196, 196, 196, 0.5) 1px 1px 3px 1px;
      img {
        height: 85px;
      }
      label{
        padding: 0 20px;
        color: #000;
        font-size: 16px;
        display: block;
        min-width: 100px;
      }
    }
    .player {
      overflow: hidden;
      background-color: #fff;
      box-shadow: rgba(196, 196, 196, 0.5) 1px 1px 3px 1px;
      label {
        float: left;
        padding: 8px 10px;
        width: 100%;
        color: #999;
        font-size: 13px;
      }
      .player-list {
        overflow: hidden;
        width: 100%;
        span {
          overflow: hidden;
          float: left;
          width: 65px;
          text-align: center;
          font-size: 14px;
          color: #000;
          margin: 10px;
          cursor: pointer;
          img {
            width: 65px;
            height: 80px;
            border-radius: 4px;
            vertical-align: middle;
          }
          p {
            margin-top: 0;
          }
          .line {
            display: block;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
    .listElement {
      max-height: 50px;
      overflow: hidden;
      transition: max-height .5s;
    }
    .leader-list{
      width: 100px;
      p{
        float: left;
        text-align: center;
      }
      img{
        width: 65px;
        height: 80px;
        border:1px solid #e8e8e8;
        border-radius: 4px;
      }
      span{
        display: block;
      }
    }
  }
}
.apply-step-warp{
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/join/heaveCompetition/ChangeData.vue